import { LisiDashboardGlobalRequestor } from "./LisiDashboardGlobalRequestor";
import { LisiDashboardGlobalData } from "./LisiDashboardGlobalData";


export const LisiDashboardGlobal = ({ selectedRange }) => {
  return (
    <div className="h-full flex gap-4 flex-1 min-h-0">
      <LisiDashboardGlobalData selectedRange={selectedRange} />
      <LisiDashboardGlobalRequestor/>
    </div>
  );
};